import { Employee } from "../types/types";
import { post } from "../util/api";

const login = async (username: string, password: string) => {
  try {
    return await post<Employee>("/login", { username, password });
  } catch (error) {
    if (error.name === "HTTPError" && error.response.status === 401) {
      return;
    }
    throw error;
  }
};

export const loginService = {
  login
};
